// -------------- Config文件里面的type --------------
// menu相关的mutation类型
export const ADD_MENU = 'ADD_MENU'
export const CLEAR_MENU = 'CLEAR_MENU'
export const SET_IS_COLLAPSE = 'SET_IS_COLLAPSE'

export const types = {
  ADD_MENU,
  CLEAR_MENU,
  SET_IS_COLLAPSE
}



// WEBPACK FOOTER //
// ./src/store/mutation-types.js